var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronDownPink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11.4 7.1",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HAN-iconen-rood_cmyk-Chevron_4_",
    transform: "translate(82.414 115.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outline_4_",
    transform: "translate(-88.707 -100.146) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477_4_",
    fill: "#E50056",
    d: "M14,6.3l1.4,1.4L11.1,12l4.3,4.3L14,17.7L8.3,12L14,6.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDownPink);
export default __webpack_public_path__ + "static/media/icon_chevron_down_pink.aa80e566c7f10afd8fb20ab52d0e73e2.svg";
export { ForwardRef as ReactComponent };